import { useState, useEffect } from 'react';
import { Icon } from '..';

import * as S from './CampaignsTable.styles';
import TableModal from './TableModal';

type HeaderType = {
  [keys: string]: string;
};

type TableRowType = {
  data: {
    [keys: string]: string | number | object | boolean | object[];
  };
  headers: HeaderType;
  formatRow?: {
    [keys: string]: Function;
  };
  formatSubRow?: {
    [keys: string]: Function;
  };
  subHeaders?: HeaderType;
  subOptionsKey?: string;
  actions: {
    action: Function;
    icon: string;
    title: string;
  }[];
  isOdd: boolean;
};

const TableRow = ({
  headers,
  formatRow,
  formatSubRow,
  subHeaders = {},
  actions,
  isOdd,
  subOptionsKey = 'subOptions',
  data: { [subOptionsKey]: options = [], ...data }
}: TableRowType) => {
  const subOptions = Array.isArray(options) ? options : [];
  const [isExtended, setIsExtended] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [modalVisibility, setModalVisibility] = useState(false);

  useEffect(() => {
    if (isExtended) {
      setTimeout(() => setShowContent(true), 200);
    } else {
      setShowContent(false);
    }
  }, [isExtended]);

  const rowKeys = Object.keys(subHeaders);
  const headersKeys = Object.keys(headers);
  return (
    <>
      <S.TableRow isOdd={isOdd}>
        {headersKeys.map(info => (
          <S.TableContent key={info} isActive={!!data.active}>
            {formatRow?.[info] ? formatRow[info](data[info]) : data[info]}
          </S.TableContent>
        ))}
        <S.ContentRow>
          {!!subOptions?.length && (
            <S.RegularButton onClick={() => setIsExtended(prev => !prev)}>
              <Icon icon={isExtended ? 'IcChevronUp' : 'IcChevronDown'} color='secondary' />
            </S.RegularButton>
          )}
          <S.RegularButton onClick={() => setModalVisibility(true)}>
            <Icon icon='IcDots' color='secondary' />
          </S.RegularButton>
        </S.ContentRow>
      </S.TableRow>
      <S.StyledSubOptionsContainer
        isOdd={isOdd}
        animate={{
          height: `${!isExtended ? 0 : 60 * (1 + (subOptions?.length || 0))}px`
        }}
        initial={{
          height: '0px'
        }}
        transition={{ type: 'spring', bounce: 0, duration: 0.2 }}
      >
        {showContent && (
          <S.StyledSubOptions colSpan={rowKeys.length + 1}>
            <S.StyledSubOptionsRow>
              {Object.values(subHeaders).map(header => (
                <S.StyledSubOptionsTitle width={100 / rowKeys?.length} isActive={!!data.active}>
                  {header}
                </S.StyledSubOptionsTitle>
              ))}
            </S.StyledSubOptionsRow>
            {subOptions?.map(subData => (
              <S.StyledSubOptionsRow>
                {Object.keys(subHeaders).map(key => (
                  <S.StyledSubOptionsData width={100 / rowKeys?.length} isActive={!!data.active}>
                    {formatSubRow?.[key] ? formatSubRow[key](subData[key]) : subData[key]}
                  </S.StyledSubOptionsData>
                ))}
              </S.StyledSubOptionsRow>
            ))}
          </S.StyledSubOptions>
        )}
      </S.StyledSubOptionsContainer>
      {modalVisibility && (
        <TableModal
          visibility={modalVisibility}
          toggleVisibility={setModalVisibility}
          actions={actions}
          data={data}
        />
      )}
    </>
  );
};

export default TableRow;
